<template>
    <component :is="element_type" v-if="boldLast">
        <span :class="cls.first"
                class='font-weight-normal'
        >{{first}}</span>
        <span class="font-weight-bold"
                :class="cls.last"
        >{{last}}</span>
    </component>
    <component :is="element_type" v-else>
        <span :class="cls.first"
                class="font-weight-bold"
        >{{first}}</span>
        <span class='font-weight-normal'
                :class="cls.last"
        >{{last}}</span>
    </component>
</template>

<script>
	import {_} from 'underscore';

	/**
	 * creates bold words from string
	 *
	 */
	export default {
		name: "bold-words",
		props: {
			element_type:{
				type:String,
                default:'span'
            },
			word: {
				type: Object
			},
			cls: {
				type: Object,
                default:function(){
                	return {
                		first:'',
                        last:''
                    }
                }
            }
		},
		mounted() {
			this.$nextTick(function () {
				this.read();
			})
		},
		data() {
			return {
				boldLast: true,
				first: '',
				last: ''
			}
		},
		methods: {
			read() {
				// split word
				if (typeof this.word.params !== 'undefined' && this.word.params !== null) {
					if (typeof this.word.params.bold !== 'undefined' && this.word.params.bold !== null) {
						if (typeof this.word.params.bold.first !== 'undefined' && this.word.params.bold.first !== null) {
							if (this.word.params.bold.first === true) {
								this.boldLast = false;
							}
						}
					}
				}

				let text = this.word.text.toString();
				let splitStr = text.trim().split(' ');

				if (this.boldLast) {
					this.last = splitStr.pop();
					this.first = splitStr.join(' ');
				}
				else {
					this.first = splitStr.shift();
					this.last = splitStr.join(' ');
				}
			}
		},
		watch: {
			word() {
				this.read();
			}
		},
	}
</script>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/BoldWords.vue